<template>
  <div class="download-page" v-loading="loading">
    <!-- 无访问权限：不显示页面真正内容 -->
    <div v-if="!loading && !hasPermission && !loginDialogVisible" class="no-permission">无访问权限</div>

    <template v-else-if="!loading && hasPermission">
      <!-- 微信打开提示 -->
      <div v-if="isWechat" class="wechat-alert">
        微信内无法下载APK，请点右上角「...」→ 在浏览器打开
      </div>

      <!-- 项目标题 -->
      <h1 class="page-title">零数通店务</h1>

      <!-- 左右布局容器 -->
      <div class="box-wrap">
        <!-- 左侧：苹果iOS 跳转App Store -->
        <a
          href="https://apps.apple.com/us/app/%E9%9B%B6%E6%95%B0%E9%80%9A%E5%BA%97%E5%8A%A1/id6774992053"
          target="_blank"
          class="ios-box"
        >
          <img src="@/assets/ios.png" alt="苹果iOS" class="icon-img" />
          <div class="text ios-text">苹果下载</div>
          <!-- <div class="tip-text">跳转App Store手动安装</div> -->
        </a>

        <!-- 右侧：安卓 点击触发JS下载，不跳转页面 -->
        <div @click="downloadApk" class="android-btn">
          <img src="@/assets/android.png" alt="安卓APP" class="icon-img" />
          <span class="text">安卓下载</span>
          <!-- <div class="tip-text">直接下载APK文件</div> -->
        </div>
      </div>
    </template>

    <!-- URL未带passwd时，弹出输入用户名和密码 -->
    <el-dialog
      title="请输入用户名和密码"
      custom-class="login-dialog"
      :visible.sync="loginDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="400px"
    >
      <div class="login-form">
        <el-input
          v-model="loginForm.cellphone"
          placeholder="请输入用户名"
          prefix-icon="el-icon-user"
        ></el-input>
        <el-input
          v-model="loginForm.password"
          type="password"
          placeholder="请输入密码"
          prefix-icon="el-icon-lock"
          @keyup.enter.native="confirmLogin"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loginLoading" @click="confirmLogin">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import md5 from "md5";
import CryptoJS from 'crypto-js'

export default {
  name: 'AppDownload',
  data() {
    return {
      apkLink: '',
      isWechat: false,
      loading: true,
      hasPermission: false,
      loginDialogVisible: false,
      loginLoading: false,
      loginForm: {
        cellphone: '',
        password: ''
      }
    }
  },
  mounted() {
    const ua = navigator.userAgent.toLowerCase()
    this.isWechat = ua.includes('micromessenger')
    const passwd = this.$route.query.passwd
    if (passwd) {
      // URL带了passwd，直接用passwd校验
      this.validateDownAddress({
        passwd: passwd
      })
    } else {
      // URL没带passwd，弹出输入用户名和密码
      this.loading = false
      this.loginDialogVisible = true
    }
  },
  methods: {
    // 校验下载地址访问权限
    async validateDownAddress(params) {
      this.loading = true
      try {
        let res = await axios.post(commonServer + "/edition/validateDownAddress", params)
        if (res.data.code === 200) {
          this.hasPermission = true
          this.getVersion()
        } else {
          this.$message.warning('无访问权限')
        }
      } catch (e) {
        this.$message.warning('无访问权限')
      } finally {
        this.loading = false
      }
    },

    // 弹出框确认：调用接口校验
    async confirmLogin() {
      if (!this.loginForm.cellphone || !this.loginForm.password) {
        this.$message.warning('请输入用户名和密码')
        return
      }
      this.loginLoading = true
      await this.validateDownAddress({
        cellphone: this.loginForm.cellphone,
        // password: this.loginForm.password
        password: CryptoJS.SHA256(md5(this.loginForm.password)).toString()
      })
      if (this.hasPermission) {
        this.loginDialogVisible = false
      }
      this.loginLoading = false
    },

    downloadApk() {
      // 动态创建隐藏a标签，无页面跳转，直接下载
      const a = document.createElement('a')
      a.href = this.apkLink
      a.download = '灵数通门店APP.apk'
      // 加入文档触发下载
      document.body.appendChild(a)
      a.referrerPolicy = "no-referrer"
      a.style.display = 'none'
      a.click()
      // 移除临时标签
      document.body.removeChild(a)
    },

    async getVersion () {
      var downLoadAndroid = "";
      var downLoadIos = "";
      let resAndroid = await axios.get(commonServer+"/edition/downAddress/android");
      if (resAndroid.data.code === 200) downLoadAndroid = resAndroid.data.data.address;
      this.apkLink = downLoadAndroid;

      let resIos = await axios.get(commonServer+"/edition/downAddress/ios");
      if (resIos.data.code === 200) downLoadIos = resIos.data.data.address;
      console.log("android.....", downLoadAndroid)
      console.log("ios.....", downLoadIos)
    }
  }
}
</script>

<style scoped>
.download-page {
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.no-permission {
  font-size: 18px;
  color: #999;
}
.login-form .el-input {
  margin-bottom: 16px;
}
.login-form .el-input:last-child {
  margin-bottom: 0;
}
.dialog-footer .el-button {
  width: 100%;
}
.wechat-alert {
  background: #fff3cd;
  color: #c46500;
  padding: 14px 18px;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  margin-bottom: 40px;
  max-width: 320px;
}
.page-title {
  font-size: 28px;
  color: #222;
  margin: 0 0 60px;
  font-weight: 600;
}
.box-wrap {
  display: flex;
  gap: 120px;
  align-items: center;
}
.ios-box, .android-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
}
.ios-box:hover, .android-btn:hover {
  opacity: 0.85;
}
.icon-img {
  width: 100px;
  height: 100px;
  object-fit: contain;
}
.text {
  margin-top: 14px;
  font-size: 16px;
  color: #222;
}
.tip-text {
  margin-top: 6px;
  font-size: 13px;
  color: #999;
}

@media screen and (max-width: 600px) {
  .box-wrap {
    flex-direction: column;
    gap: 40px;
  }
}
</style>

<!-- 登录弹窗宽度适配（非 scoped，作用于 el-dialog 内部元素） -->
<style>
.login-dialog {
  max-width: 400px;
}

@media screen and (max-width: 600px) {
  .login-dialog {
    width: 88% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/download.vue